"use strict";function setData$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setData$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.clipboardData.setData";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.6.1"},_a)),exports.setData$=setData$,exports.default=setData$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/clipboardData/setData.js
// module id = 924
// module chunks = 106